import React, { lazy, Suspense } from 'react';

import getExperiment from 'lib/experiments/simple-test';

const IS_GAMMA_HEADER = getExperiment('gammaHeader').get('enabled');

let GammaEmbedded = null;

if (IS_GAMMA_HEADER) {
  GammaEmbedded = lazy(() =>
    import(/* webpackChunkName: "gamma-embedded" */ 'gamma/embedded'),
  );
}

/**
 * When the Gamma header is enabled, invoke the render prop with the Gamma
 * depencencies (using Suspense to wait for the chunk to load).
 */
const GammaProvider = (props) => {
  return (
    <Suspense fallback={null}>
      <GammaEmbedded>{(module) => props.children(module)}</GammaEmbedded>
    </Suspense>
  );
};

/**
 * When the Gamma header is not enabled, invoke the render prop with an empty
 * object
 */
const DefaultProvider = (props) => props.children({});

export const GammaContextProvider = (props) => {
  return IS_GAMMA_HEADER ? (
    <GammaProvider {...props} />
  ) : (
    <DefaultProvider {...props} />
  );
};



// WEBPACK FOOTER //
// ./app/scripts/views/chrome/gamma-context-provider.js